import React from 'react';
import { SmartNetworkProductCard } from './NetworkProductCard';
import { NetworkProductList } from './NetworkProductList';
import { Repeater } from '../../components/Forms/Repeater'
import { Surface } from '../../styles/Containers';
import { PostSelect } from '../../components/Content/PostSelect';


const ProductItem = ({ item, onChange }) => {

    return (
        <Surface width="100%" variant="inverse">
            <PostSelect buttonText="Select Product" ListComponent={NetworkProductList} PreviewComponent={SmartNetworkProductCard} value={item.productId} onChange={(value) => onChange(item, 'productId', value)} />
        </Surface>
    )
}


export const NetworkProductSelector = ({ value = [], onChange }) => {

    const repeaterOnChange = (updatedData) => {
        onChange([...updatedData]);
    }

    return (
        <Repeater id="networkproducts" datasource={value} component={ProductItem} onChange={repeaterOnChange} buttonText="Add Network" />
    )
}